import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, NavItem, Image, Container, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import isEqual from 'react-fast-compare';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';
import { Badge } from 'ecs-react-components/dist/index.es';

import history from '../../history';
import { links } from '../../shared/links';
import { messages } from './Menu.i18n';
import { mapCapabilities } from '../../pages/HomePage/capability-mapper';
import { getUnreadCount } from '../../redux/modules/secure-message/secure-message-middleware';
import { logout } from '../../redux/modules/auth/auth-middleware';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';
import { findCcdaExternalSystems } from '../../redux/modules/health-summary/external-systems-mapper';
import { mapResourcesCapabilities } from './resources-mapper';
import NavSeparator from './NavSeparator';
import NavItemSeparator from './NavItemSeparator';
import LanguageSelectionDropdown from '../LanguageSelectionDropdown/LanguageSelectionDropdown';
import { SecureMessageNavLink } from '../../components/SecureMessage/SecureMessageNavLink';


class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hamburgerMenuOpen: false,
    };
    this.toggleHamburgerMenu = this.toggleHamburgerMenu.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props.capabilities, nextProps.capabilities) &&
      isEqual(this.props.stateCounter, nextProps.stateCounter) &&
      isEqual(this.props.externalSystems, nextProps.externalSystems) &&
      isEqual(this.props.isDedicatedWorkflow, nextProps.isDedicatedWorkflow) &&
      isEqual(this.props.patient, nextProps.patient) &&
      isEqual(this.props.user, nextProps.user) &&
      isEqual(this.state, nextState));
  }

  logout = (e) => {
    e.preventDefault();
    this.props.dispatch(MsgBarActions.dismissMessage());
    this.props.dispatch(logout());
    return false;
  };

  toggleHamburgerMenu(shouldDisplayMessage) {
    const { dispatch, patient, isAuthenticated, isDedicatedWorkflow } = this.props;
    if (isAuthenticated && !isDedicatedWorkflow && patient && patient.patientId) {
      // ***** HACK ALERT!!! ***** Stupid workaround because there is no push mechanism
      dispatch(getUnreadCount(patient.patientId));
    }
    this.setState({ hamburgerMenuOpen: !this.state.hamburgerMenuOpen });
    if (!shouldDisplayMessage) {
      dispatch(MsgBarActions.dismissMessage());
    }
  }

  displayMuCcdaNotConfiguredMessage = (handleToggleHamburgerMenu) => () => {
    this.props.dispatch(MsgBarActions.showErrorMessage('ccdaNotConfiguredError'));
    if (handleToggleHamburgerMenu) {
      handleToggleHamburgerMenu(true);
    }
  }

  buildLogo(navigation) {
    const { formatMessage } = this.props.intl;
    if (navigation == null) {
      return (<div className="navbar-brand navbar-logo">
      <div>
      <Image src={this.props.logo} className="img-responsive"
        alt={ formatMessage(messages.headerLogo) + this.props.facilityName }
      />
      </div>
              </div>);
    }
    return (<div className="navbar-brand navbar-logo">
        <NavLink {...navigation} >
          <Image src={this.props.logo} className="img-responsive"
            alt={ formatMessage(messages.headerLogo) + this.props.facilityName }
          />
        </NavLink>
            </div>);
  }

  handleClick = (e) => {
    e.preventDefault();
    let route = '/';
    if (this.isKiosk()) {
      route = '/kioskQuestionnaires';
    }
    if (!this.props.isDedicatedWorkflow) {
      history.push(route);
    }
  }

  isKiosk() {
    let isKiosk = false;
    if (window.location.pathname.toLowerCase().indexOf('kiosk') > -1) {
      isKiosk = true;
    } else if (this.props.loginType &&
      [
        'patientkioskmanagement',
        'patientkioskuser',
        'patientlinkuser',
      ].indexOf(this.props.loginType.toLowerCase()) > -1) {
      isKiosk = true;
    }
    return isKiosk;
  }

  renderLogo() {
    let navigation;
    if (!this.props.isDedicatedWorkflow && !this.isKiosk()) {
      navigation = {
        to: '/',
      };
    }
    return this.buildLogo(navigation);
  }

  renderFacilityName() {
    let href = '#';
    if (this.isKiosk()) {
      href = '/kioskQuestionnaires';
    }
    return (
      <a className="navbar-brand" href={href} onClick={this.handleClick}>{this.props.facilityName}</a>
    );
  }

  renderUnauthenticatedNavItems() {
    return (
      <span></span>
    );
  }

  renderHealthSummaryLink(isHealthSummaryEnabled, ccdaExternalSystems, className, handleToggleHamburgerMenu) {
    if (!isHealthSummaryEnabled) {
      return null;
    }
    if (ccdaExternalSystems && ccdaExternalSystems.length) {
      return (
        <LinkContainer className={className} to="/health-summary" >
          <Dropdown.Item onClick={ handleToggleHamburgerMenu } as="li">
            <FormattedMessage {...links.healthSummary} />
          </Dropdown.Item>
        </LinkContainer>
      );
    }

    return (
      <Dropdown.Item onClick={ this.displayMuCcdaNotConfiguredMessage(handleToggleHamburgerMenu) }
        as="li" className={className}
      >
        <FormattedMessage {...links.healthSummary} />
      </Dropdown.Item>
    );
  }

  renderAuthDesktopViewResourcesNavDropdown() {
    const {
      capabilities,
      intl: {
        formatMessage,
      } } = this.props;

    let menuItems = mapResourcesCapabilities(capabilities);
    menuItems = menuItems.filter((item) => item.isDesktopMenuItem);
    if (!menuItems || !menuItems.length) {
      return null;
    }
    menuItems.sort((a, b) => a.DesktopMenuSortOrder - b.DesktopMenuSortOrder);
    return [
      <Dropdown id="resourcesmenu" as="li"
        key="resourcesNavDropdown"
      >
        <Dropdown.Toggle className="nav-link" as="a" role="button">
        {formatMessage(messages.navigation.resources)}
        </Dropdown.Toggle>
        <Dropdown.Menu as="ul">
          {
            menuItems.map((item, key) =>
              (
              <LinkContainer
                to={item.route}
                key={'menuitem-' + key}
              >
                <Dropdown.Item role="menuitem" as="li" key={`menuitem${key}`}>
                <FormattedMessage {...links[item.id]} />
                </Dropdown.Item>
              </LinkContainer>
              ))
          }
        </Dropdown.Menu>
      </Dropdown>,
      <NavSeparator key="desktopmenuSplitter1" />,
      <LanguageSelectionDropdown
        selectId="languageDropdown-desktop"
        key="languageDropdownMenuItem"
        inMenu
        visibilityClass=""
      />,
      <NavSeparator key="desktopmenuSplitter2" />,
    ];
  }

  renderAuthHamburgerViewResources() {
    const {
      capabilities,
    } = this.props;

    let menuItems = mapResourcesCapabilities(capabilities)
      .filter((item) => item.isHamburgerMenuItem);

    if (!menuItems) {
      return null;
    }
    menuItems = menuItems.filter((item) => item.isHamburgerMenuItem);
    menuItems.sort((a, b) => a.hamburgerMenuSortOrder - b.hamburgerMenuSortOrder);

    return [
      menuItems.map((item, key) => (
        <LinkContainer className="d-xs-inline d-sm-inline d-md-none"
          to={item.route}
          key={'hamburgermenuitem-' + key}
        >
          <NavItem href="#" onClick={ this.toggleHamburgerMenu }>
            <FormattedMessage {...links[item.id]} />
          </NavItem>
        </LinkContainer>
      )),
      <LanguageSelectionDropdown
        selectId="languageDropdown-hamburger"
        key="languageDropdownMenuItem"
        inMenu
        visibilityClass="d-xs-inline d-sm-inline d-md-none"
      />,
    ];
  }

  renderKioskNavItems() {
    const {
      intl: {
        formatMessage,
      },
      user,
      patient,
    } = this.props;
    let userName = {};
    if (user && user.firstName && user.lastName) {
      userName = {
        0: user.firstName,
        1: user.lastName,
      };
    } else {
      userName = {
        0: patient.firstName,
        1: patient.lastName,
      };
    }
    const fullName = formatMessage(messages.displayNameFormat, userName);
    return (
      <Nav className="navbar-right me-auto mb-lg-0" as="ul">
        <NavItem onClick={ this.toggleHamburgerMenu }>
        </NavItem>
        <LanguageSelectionDropdown
          selectId="languageDropdown-desktop"
          key="languageDropdownMenuItem"
          inMenu
          visibilityClass=""
        />
        <NavSeparator key="desktopmenuSplitter2" />
        <Dropdown id="userAccountMenu" as="li">
          <Dropdown.Toggle className="nav-link" as="a" role="button">
            {fullName}
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul">
          <LinkContainer to="/logout" onClick={this.logout}>
            <Dropdown.Item as="li">
              <FormattedMessage {...links.logout} />
            </Dropdown.Item>
          </LinkContainer>
          </Dropdown.Menu>
        </Dropdown>
      </Nav>
    );
  }

  renderAuthenticatedNavItems() {
    if (this.isKiosk()) {
      return this.renderKioskNavItems();
    }
    if (this.props.isDedicatedWorkflow) {
      return null;
    }
    const {
      intl: {
        formatMessage,
      },
      externalSystems,
      capabilities,
      stateCounter,
      patient,
      dispatch,
      user,
    } = this.props;

    const tabs = mapCapabilities(
      capabilities,
      stateCounter,
      patient.patientId,
      dispatch);
    const fullName = user.firstName + ' ' + user.lastName;
    tabs.sort((a, b) => a.hamburgerMenuSortOrder - b.hamburgerMenuSortOrder);

    const contactUsTab = tabs.find((a) => a.id === 'contactus');
    const contactUsLink = (contactUsTab) ?
      (
          <NavItem aria-label={ formatMessage(messages.screenReader.contactUsLink)} as="li">
            <LinkContainer to="/contact-us">
            <Nav.Link href="#"><FormattedMessage {...links.contactus} /></Nav.Link>
            </LinkContainer>
          </NavItem>) : null;
    const contactUsSplitter = (contactUsTab) ?
        <NavSeparator /> : null;
    const secureMessageTab = tabs.find((a) => a.id === 'securemessages');
    const secureMessageIcon = (secureMessageTab) ?
      (
        <SecureMessageNavLink tab={secureMessageTab}/>) : null;
    const secureMessageSplitter = (secureMessageTab) ?
      <NavSeparator /> : null;

    const dashBoardTab = tabs.find((x) => x.id === 'dashboard');
    const healthSummary = dashBoardTab ? dashBoardTab.hasHealthSummary : false;
    let ccdaExternalSystems = null;
    if (externalSystems && externalSystems.length) {
      ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
    }

    const healthSummaryLink = this.renderHealthSummaryLink(healthSummary, ccdaExternalSystems);
    return (
      <Nav className="navbar-right me-auto mb-lg-0" as="ul">
        {
          tabs.map((tab, index) => (
            tab.route ?
            <Nav.Item className="d-lg-none" onClick={ this.toggleHamburgerMenu } key={index} as="li">
            <LinkContainer className="d-lg-none" eventKey={index} key={index} to={tab.route}
              data-qa-tab={'hb_' + tab.id}
            >
              <Nav.Link eventKey={tab.route}>
              <FormattedMessage {...links[tab.id]} />
                <Badge badgeProperties={tab.badgeProperties}/>
              </Nav.Link>
            </LinkContainer>
            </Nav.Item>
              :
              null
          ))
        }
        <li className="nav-item d-lg-none"><hr /></li>


        {this.renderAuthDesktopViewResourcesNavDropdown()}

        { contactUsLink }
        { contactUsSplitter }

        { secureMessageIcon }
        { secureMessageSplitter }
        <li className="nav-item d-lg-none"><hr /></li>
        <Dropdown id="userAccountMenu" as="li">
          <Dropdown.Toggle className="nav-link" as="a" role="button">
            {fullName}
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul">
          <LinkContainer to="/account-settings">
            <Dropdown.Item role="menuitem" as="li">
              <FormattedMessage {...links.accountSettings} />
            </Dropdown.Item>
          </LinkContainer>
          {healthSummaryLink}
          <LinkContainer to="/personal-data">
            <Dropdown.Item as="li">
              <FormattedMessage {...links.dataProtection} />
            </Dropdown.Item>
          </LinkContainer>

          <NavItemSeparator className="divider" />

          <LinkContainer to="/logout" onClick={this.logout}>
            <Dropdown.Item as="li">
              <FormattedMessage {...links.logout} />
            </Dropdown.Item>
          </LinkContainer>
          </Dropdown.Menu>
        </Dropdown>
      </Nav>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { isAuthenticated, isEulaAccepted } = this.props;
    if (this.props.capabilities && this.props.capabilities.length > 0) {
      return (
        <div>
          <Navbar expand="lg" variant="" id="header">
            <Container fluid>
            { isAuthenticated ?
              this.renderFacilityName()
              :
              this.renderLogo() }
              <Navbar.Toggle onClick={ this.toggleHamburgerMenu }>
                <span className="sr-only">{ formatMessage(messages.navigation.toggleMenu) }</span>
                <span className="navbar-toggler-icon">
                  <span className="d-none">{ formatMessage(messages.navigation.hamburgerBar) }</span>
                </span>
                <div className="hamburger-bars clearfix">
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </div>
              </Navbar.Toggle>
            <Navbar.Collapse in={ this.state.hamburgerMenuOpen }>
              {
                isAuthenticated && (isEulaAccepted || this.isKiosk()) ?
                  this.renderAuthenticatedNavItems() :
                  this.renderUnauthenticatedNavItems()
              }
            </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>
      );
    }

    return (
      <div>
          <Navbar id="header" expand="lg" variant="" className="navbar-bottom-border">
            <Container fluid>
            { isAuthenticated ?
              this.renderFacilityName()
              :
              this.renderLogo() }
            </Container>
          </Navbar>
      </div>
    );
  }
}

Menu.propTypes = {
  facilityName: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isEulaAccepted: PropTypes.bool,
  capabilities: PropTypes.array,
  user: PropTypes.object,
  logo: PropTypes.string,
  intl: PropTypes.object,
  isDedicatedWorkflow: PropTypes.bool,
  dispatch: PropTypes.func,
  patient: PropTypes.object,
  loginType: PropTypes.string,
  stateCounter: PropTypes.shape({
    education: PropTypes.number,
    testresults: PropTypes.number,
    medicalnotes: PropTypes.number,
    questionnaires: PropTypes.number,
    treatmentsummary: PropTypes.number,
    securemessages: PropTypes.number,
  }),
  externalSystems: PropTypes.array,
};

const mapStateToProps = (state) => ({
  facilityName: state.facility.facilityName,
  capabilities: state.capability.capabilities,
  isAuthenticated: state.profile.auth.isAuthenticated,
  isEulaAccepted: state.profile.user.isEulaAccepted,
  user: state.profile.user,
  logo: state.facility.logo,
  isDedicatedWorkflow: state.workflow.isDedicatedWorkflow,
  patient: state.profile.patient,
  loginType: state.profile.auth.loginType,
  stateCounter: {
    education: state.education.unreadArticlesCount,
    testresults: state.testResults.notReviewedTestResultsCount,
    medicalnotes: state.medicalNotes.isNotReviewedByPatientCount,
    questionnaires: state.questionnaires.newQuestionnaireCount,
    treatmentsummary: state.treatmentSummary.unseenTreatmentSummaryItems,
    securemessages: state.secureMessage.unreadCount,
  },
  externalSystems: state.externalSystems.externalSystems,
});

export default connect(mapStateToProps)(injectIntl(Menu));